// extracted by mini-css-extract-plugin
export var createdDate = "_lz-1";
export var divider = "_lz-2";
export var headerDivider = "_lz-3";
export var messagesCard = "_lz-0";
export var messagesContainer = "_lz-6";
export var messagesContainerWrapper = "_lz-4";
export var showLeftPanelButton = "_lz-8";
export var topButtons = "_lz-7";
export var withPadding = "_lz-5";